export const embed = (url: string) => {
  return `<div style="width: 100px; height:100px;"><iframe allow="camera;fullscreen;xr-spatial-tracking;xr" src="${url}" style="width: 100%; height: 100%"> </iframe></div>`
}
